export default "__VITE_ASSET__1af7a02f__"